import Id from './IdFactory';

export default function createRootDirectories(providedDirectoryRoots={}){

  const rootNames = ["imageSets","figurePanels","figurePanelTemplates"]

  const datatypeSpecificDirectoryRoots = Object.fromEntries(rootNames.map(name => ([name,(providedDirectoryRoots[name]||Id())])));
  return datatypeSpecificDirectoryRoots;

}
